import React, { memo } from "react";
import { useSuperpowers } from "./index.hooks";
import { Box, IconButton, Stack } from "@mui/material";

import FreezePowerIcon from "assets/ui-icons/freeze-power-icon.png";
import FixTilePowerIcon from "assets/ui-icons/fix-tile-power-icon.png";

type SuperpowersProps = {};

export const Superpowers = memo(({}: SuperpowersProps) => {
  const {
    onFreezeTimePowerClicked,
    onFixTilePowerClicked,
    freezeTimePowerUsed,
    isFreezeTimePowerDisabled,
    isFixTilePowerDisabled,
  } = useSuperpowers();

  return (
    <Stack
      direction="row"
      justifyContent="end"
      spacing={1}
      sx={{
        pr: {
          xs: 2,
          md: 6,
        },
      }}
    >
      <IconButton
        sx={{
          position: "relative",
          borderRadius: "50%",
          backgroundColor: "#FFF!important",
          display: "flex",
          p: 1,
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
        disabled={isFreezeTimePowerDisabled}
        onClick={onFreezeTimePowerClicked}
      >
        <Box
          component="img"
          src={FreezePowerIcon}
          sx={{
            transition: "filter 0.3s",
            width: { xs: 42, md: 60 },
            filter: isFreezeTimePowerDisabled ? "grayscale(100%)" : "none",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            zIndex: freezeTimePowerUsed ? 10 : -5,
            transition: "top 5s linear",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(51,51,51,0.8)",
            top: freezeTimePowerUsed ? "100%" : 0,
          }}
        />
      </IconButton>
      <IconButton
        sx={{
          borderRadius: "50%",
          backgroundColor: "#FFF!important",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        disabled={isFixTilePowerDisabled}
        onClick={onFixTilePowerClicked}
      >
        <Box
          component="img"
          src={FixTilePowerIcon}
          sx={{
            transition: "filter 0.3s",
            width: { xs: 42, md: 60 },
            filter: isFixTilePowerDisabled ? "grayscale(100%)" : "none",
          }}
        />
      </IconButton>
    </Stack>
  );
});
